import styled from "styled-components";
import {below} from "../../assets/css/media";

interface ITextarea {
	readonly max_width?: string;
}

export const Textarea = styled.textarea`
	width: 100%;
	height: 150px;
	max-width: ${({max_width}: ITextarea) => max_width || "358px"};
	border: 1px solid #cccccc;
	border-radius: 4px;
	padding: 8px 16px;
	box-sizing: border-box;
	::placeholder {
		font-size: 14px;
	}

	${below.desktop`
		max-width:100%;
	`};
`;

export default Textarea;
